module.exports = __webpack_public_path__ + "img/tertiary_4x2.4a55dd06.svg";